import { useState, useEffect, ReactNode } from "react";

// ui
import {
  Button,
  Box,
  Paper,
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  IconButton,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { PoModalShell } from "./common/PoModalShell";
import { PoButton } from "./common/PoButton";
import { PoTextField, PoHelper, PoField, PoLabel, PoSelect, PoCheckRow, PoCheckbox } from "./common/PoForm";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

// dnd
import {
  DragDropContext,
  Droppable,
  Draggable,
  DropResult,
  DraggableProvided,
  DraggableStateSnapshot,
} from "react-beautiful-dnd";

// InterFace
import { LIST_POST } from "../config/const";
// jotai
import { useAtomValue } from "jotai";
import { AppAtoms } from "../lib/store";
// ★cmd-po_1221 R9: 編集成功をトースト→結果モーダルへ統一
import { DataAddModalResult } from "./DataAddModalResult";

interface InputProductOptionProps {
  selectOption: any;
  setEelectOption: (select_option: any) => void;
  editProductOptionPlans: {
    service_plan_id: number;
    service_plan_name: string;
  }[];
  editProductOptionContents: {
    service_content_id: number;
    service_content_name: string;
  }[];
  editTossUpFormOptionProducts: {
    high_rank_company_name: string;
    product_id: number;
    product_name: string;
  }[];
  editOutsideServices: {
    outside_entry_form_service_id: number;
    outside_entry_form_service_name: string;
  }[];
  optionNameList: string[];
  editProduct: { [key: string]: any } | null;
  formType?: "entry_form" | "toss_up_form" | "outside_entry_form";
}

function InputProductOption(props: InputProductOptionProps) {
  const {
    selectOption,
    setEelectOption,
    editProductOptionPlans,
    editProductOptionContents,
    editTossUpFormOptionProducts,
    editOutsideServices,
    optionNameList,
    editProduct,
    formType,
  } = props;

  const pathname = useAtomValue(AppAtoms.pathname);
  const resolvedFormType = formType ?? (pathname === "/entry_form" ? "entry_form" : pathname === "/toss_up_form" ? "toss_up_form" : pathname === "/outside_entry_form" ? "outside_entry_form" : null);
  const [selectNameList, setSelectNameList] = useState<string[]>([]);
  useEffect(() => {
    if (editProduct && editProduct.product_option) {
      if (selectOption.depend_option_name !== "他質問に依存しない") {
        editProduct.product_option.map((optionInf: any) => {
          if (optionInf.option_name === selectOption.depend_option_name) {
            setSelectNameList(optionInf.option_select);
          }
        });
      } else {
        setSelectNameList([]);
      }
    }
  }, [selectOption.depend_option_name]);
  return (
    <>
      <SerchTextField
        width="calc(100% - 10px)"
        label="質問名"
        helperText={""}
        value={selectOption["option_name"]}
        setValue={(value) => {
          setEelectOption({
            ...selectOption,
            option_name: value,
          });
        }}
        dataKey={""}
        addData={{}}
        testId="product-edit-field-option_name"
        fieldKey="option_name"
        required={true}
      />
      <PoField testId="product-edit-field-option_type" fieldKey="option_type">
        <PoLabel required={true}>質問区分</PoLabel>
        <PoSelect
          labelId="serch-input-label"
          id="serch-input"
          value={selectOption["option_type"]}
          onChange={(e) => {
            setEelectOption({
              ...selectOption,
              option_type: Number(e.target.value),
              option_default_value: "",
              change_value_conf: 0,
              tel_flg: 0,
              name_flg: 0,
              company_name_flg: 0,
              zip_code_flg: 0,
              address_flg: 0,
              space_flg: 0,
              mail_address_flg: 0,
              form_tel_flg: 0,
              multi_text_flg: 0,
              contract_number_flg: 0,
              half_width_number_flg: 0,
              option_select: [""],
            });
          }}
          sx={{ height: 36, fontSize: 13, borderRadius: "var(--radius-sm, 6px)", textAlign: "end" }}
        >
          {LIST_POST["option_type"].map((input, i) => (
            <MenuItem
              key={"input" + i}
              value={input.id}
              sx={{ fontSize: "14px", height: input.value === "" ? "14px" : "24px" }}
            >
              {input.value}
            </MenuItem>
          ))}
        </PoSelect>
      </PoField>
      {selectOption["option_type"] === 0 ? (
        <PoField testId="product-edit-field-flg" fieldKey="flg">
          <PoLabel>フラグ設定</PoLabel>
          <PoSelect
              labelId="serch-input-label"
              id="serch-input"
              value={
                selectOption["tel_flg"] == 1
                  ? 1
                  : selectOption["name_flg"] == 1
                    ? 2
                    : selectOption["zip_code_flg"] == 1
                      ? 3
                      : selectOption["address_flg"] == 1
                        ? 4
                        : selectOption["space_flg"] == 1
                          ? 5
                          : selectOption["mail_address_flg"] == 1
                            ? 6
                            : selectOption["form_tel_flg"] == 1
                              ? 7
                              : selectOption["multi_text_flg"] == 1
                                ? 8
                                : selectOption["company_name_flg"] == 1
                                  ? 9
                                  : selectOption["contract_number_flg"] == 1
                                    ? 10
                                    : selectOption["half_width_number_flg"] == 1
                                      ? 11
                                      : 0
              }
              onChange={(e) => {
                if (Number(e.target.value) === 0) {
                  setEelectOption({
                    ...selectOption,
                    tel_flg: 0,
                    name_flg: 0,
                    company_name_flg: 0,
                    zip_code_flg: 0,
                    address_flg: 0,
                    space_flg: 0,
                    mail_address_flg: 0,
                    form_tel_flg: 0,
                    multi_text_flg: 0,
                    contract_number_flg: 0,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 1) {
                  setEelectOption({
                    ...selectOption,
                    required_optional: 1,
                    depend_product_ids: [],
                    depend_plan_ids: [],
                    depend_content_ids: [],
                    depend_outside_entry_form_service_ids: [],
                    depend_option_name: "他質問に依存しない",
                    depend_select_names: [],
                    outside_form_display: 0,
                    sns_send: 1,
                    tel_flg: 1,
                    name_flg: 0,
                    company_name_flg: 0,
                    zip_code_flg: 0,
                    address_flg: 0,
                    space_flg: 0,
                    mail_address_flg: 0,
                    form_tel_flg: 0,
                    multi_text_flg: 0,
                    contract_number_flg: 0,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 2) {
                  setEelectOption({
                    ...selectOption,
                    required_optional: 1,
                    depend_product_ids: [],
                    depend_plan_ids: [],
                    depend_content_ids: [],
                    depend_outside_entry_form_service_ids: [],
                    depend_option_name: "他質問に依存しない",
                    depend_select_names: [],
                    outside_form_display: 0,
                    sns_send: 1,
                    tel_flg: 0,
                    name_flg: 1,
                    company_name_flg: 0,
                    zip_code_flg: 0,
                    address_flg: 0,
                    space_flg: 0,
                    mail_address_flg: 0,
                    form_tel_flg: 0,
                    multi_text_flg: 0,
                    contract_number_flg: 0,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 3) {
                  setEelectOption({
                    ...selectOption,
                    tel_flg: 0,
                    name_flg: 0,
                    company_name_flg: 0,
                    zip_code_flg: 1,
                    address_flg: 0,
                    space_flg: 0,
                    mail_address_flg: 0,
                    form_tel_flg: 0,
                    multi_text_flg: 0,
                    contract_number_flg: 0,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 4) {
                  setEelectOption({
                    ...selectOption,
                    tel_flg: 0,
                    name_flg: 0,
                    company_name_flg: 0,
                    zip_code_flg: 0,
                    address_flg: 1,
                    space_flg: 0,
                    mail_address_flg: 0,
                    form_tel_flg: 0,
                    multi_text_flg: 0,
                    contract_number_flg: 0,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 5) {
                  setEelectOption({
                    ...selectOption,
                    tel_flg: 0,
                    name_flg: 0,
                    company_name_flg: 0,
                    zip_code_flg: 0,
                    address_flg: 0,
                    space_flg: 1,
                    mail_address_flg: 0,
                    form_tel_flg: 0,
                    multi_text_flg: 0,
                    contract_number_flg: 0,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 6) {
                  setEelectOption({
                    ...selectOption,
                    tel_flg: 0,
                    name_flg: 0,
                    company_name_flg: 0,
                    zip_code_flg: 0,
                    address_flg: 0,
                    space_flg: 0,
                    mail_address_flg: 1,
                    form_tel_flg: 0,
                    multi_text_flg: 0,
                    contract_number_flg: 0,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 7) {
                  setEelectOption({
                    ...selectOption,
                    tel_flg: 0,
                    name_flg: 0,
                    company_name_flg: 0,
                    zip_code_flg: 0,
                    address_flg: 0,
                    space_flg: 0,
                    mail_address_flg: 0,
                    form_tel_flg: 1,
                    multi_text_flg: 0,
                    contract_number_flg: 0,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 8) {
                  setEelectOption({
                    ...selectOption,
                    tel_flg: 0,
                    name_flg: 0,
                    company_name_flg: 0,
                    zip_code_flg: 0,
                    address_flg: 0,
                    space_flg: 0,
                    mail_address_flg: 0,
                    form_tel_flg: 0,
                    multi_text_flg: 1,
                    contract_number_flg: 0,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 9) {
                  setEelectOption({
                    ...selectOption,
                    required_optional: 1,
                    depend_product_ids: [],
                    depend_plan_ids: [],
                    depend_content_ids: [],
                    depend_outside_entry_form_service_ids: [],
                    depend_option_name: "他質問に依存しない",
                    depend_select_names: [],
                    outside_form_display: 0,
                    sns_send: 1,
                    tel_flg: 0,
                    name_flg: 0,
                    company_name_flg: 1,
                    zip_code_flg: 0,
                    address_flg: 0,
                    space_flg: 0,
                    mail_address_flg: 0,
                    form_tel_flg: 0,
                    multi_text_flg: 0,
                    contract_number_flg: 0,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 10) {
                  setEelectOption({
                    ...selectOption,
                    tel_flg: 0,
                    name_flg: 0,
                    company_name_flg: 0,
                    zip_code_flg: 0,
                    address_flg: 0,
                    space_flg: 0,
                    mail_address_flg: 0,
                    form_tel_flg: 0,
                    multi_text_flg: 0,
                    contract_number_flg: 1,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 11) {
                  setEelectOption({
                    ...selectOption,
                    tel_flg: 0,
                    name_flg: 0,
                    company_name_flg: 0,
                    zip_code_flg: 0,
                    address_flg: 0,
                    space_flg: 0,
                    mail_address_flg: 0,
                    form_tel_flg: 0,
                    multi_text_flg: 0,
                    contract_number_flg: 0,
                    half_width_number_flg: 1,
                  });
                }
              }}
              sx={{ height: 36, fontSize: 13, borderRadius: "var(--radius-sm, 6px)", textAlign: "end" }}
            >
              {resolvedFormType === "entry_form"
                ? (
                    LIST_POST["entry_form_option_flg"] as {
                      id: number;
                      value: string;
                    }[]
                  )
                    .filter(
                      (input) =>
                        input.id !== 10 ||
                        (String(editProduct?.product_key) === "0" &&
                          String(editProduct?.product_contract_number) === "1"),
                    )
                    .map((input, i) => (
                      <MenuItem
                        key={"input" + i}
                        value={input.id}
                        sx={{
                          fontSize: "14px",
                          height: input.value === "" ? "14px" : "24px",
                        }}
                      >
                        {input.value}
                      </MenuItem>
                    ))
                : resolvedFormType === "outside_entry_form"
                  ? LIST_POST["contract_option_flg"].map((input, i) => (
                      <MenuItem
                        key={"input" + i}
                        value={input.id}
                        sx={{
                          fontSize: "14px",
                          height: input.value === "" ? "14px" : "24px",
                        }}
                      >
                        {input.value}
                      </MenuItem>
                    ))
                  : resolvedFormType === "toss_up_form"
                    ? LIST_POST["toss_up_option_flg"].map((input, i) => {
                        return (
                          <MenuItem
                            key={"input" + i}
                            value={input.id}
                            sx={{
                              fontSize: "14px",
                              height: input.value === "" ? "14px" : "24px",
                            }}
                          >
                            {input.value}
                          </MenuItem>
                        );
                      })
                    : null}
          </PoSelect>
        </PoField>
      ) : selectOption["option_type"] === 1 ||
        selectOption["option_type"] === 2 ? (
        <Box data-testid="product-edit-dep-block" sx={{ borderLeft: "3px solid var(--color-kohaku, #d97706)", paddingLeft: "var(--sp-3, 12px)", display: "flex", flexDirection: "column", gap: "var(--sp-4, 16px)", marginTop: "calc(-1 * var(--sp-2, 8px))" }}>
          {selectOption.option_select.map(
            (option_select: string, select_i: number) => {
              return (
                <Box
                  key={"addBoxOptionSelect_" + select_i}
                  data-testid="product-edit-opt-row"
                  sx={{ display: "flex", alignItems: "center", gap: "var(--sp-2, 8px)", marginBottom: "var(--sp-2, 8px)" }}
                >
                  <SerchTextField
                    width="100%"
                    key={"serchColumnBubun" + select_i}
                    label={"選択肢 - " + (select_i + 1)}
                    helperText={""}
                    value={option_select}
                    setValue={(value) => {
                      let _option_select = selectOption.option_select.concat();
                      _option_select[select_i] = value;
                      setEelectOption({
                        ...selectOption,
                        option_select: _option_select,
                      });
                    }}
                    dataKey={""}
                    addData={{}}
                  />
                  {selectOption.option_select.length > 1 ? (
                    <IconButton
                      data-testid="product-edit-opt-remove"
                      className="opt-ic"
                      size="small"
                      sx={{ width: 26, height: 26, color: "var(--color-sumi-muted, #9ca3af)" }}
                      onClick={() => {
                        let _option_select = selectOption.option_select.concat();
                        _option_select = _option_select.filter(
                          (_product_option: string, _select_i: number) =>
                            select_i !== _select_i,
                        );
                        setEelectOption({
                          ...selectOption,
                          option_select: _option_select,
                        });
                      }}
                    >
                      <RemoveCircleOutlineIcon fontSize="small" />
                    </IconButton>
                  ) : null}
                </Box>
              );
            },
          )}
          <Box data-testid="product-edit-opt-add-row" sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              data-testid="product-edit-opt-add"
              onClick={() => {
                let _option_select = selectOption.option_select.concat();
                _option_select.push("");
                setEelectOption({
                  ...selectOption,
                  option_select: _option_select,
                });
              }}
            >
              <AddCircleOutlineIcon fontSize="medium" />
            </Button>
          </Box>
        </Box>
      ) : null}
      <PoField testId="product-edit-field-required_optional" fieldKey="required_optional">
        <PoLabel>必須フラグ</PoLabel>
        <PoCheckRow>
          <PoCheckbox
            disabled={
              editProduct?.product_key === "1" && selectOption["tel_flg"] === 1
            }
            checked={selectOption["required_optional"] === 1}
            onChange={() => {
              setEelectOption({
                ...selectOption,
                required_optional:
                  selectOption["required_optional"] === 1 ? 0 : 1,
              });
            }}
          />
          <span>必須項目とする場合はチェックしてください。</span>
        </PoCheckRow>
      </PoField>
      {resolvedFormType === "outside_entry_form" &&
      selectOption["tel_flg"] != 1 &&
      selectOption["name_flg"] != 1 &&
      selectOption["company_name_flg"] != 1 ? (
        <PoField testId="product-edit-field-outside_form_display" fieldKey="outside_form_display">
          <PoLabel>外部ETフォームでの表示</PoLabel>
          <PoSelect
            labelId="serch-input-label"
            id="serch-input"
            value={selectOption["outside_form_display"]}
            onChange={(e) => {
              setEelectOption({
                ...selectOption,
                outside_form_display: Number(e.target.value),
              });
            }}
            sx={{ height: 36, fontSize: 13, borderRadius: "var(--radius-sm, 6px)", textAlign: "end" }}
          >
            {LIST_POST["outside_form_display"].map((input, i) => (
              <MenuItem key={"input" + i} value={input.id} sx={{ fontSize: "14px", height: input.value === "" ? "14px" : "24px" }}>
                {input.value}
              </MenuItem>
            ))}
          </PoSelect>
          <PoHelper sx={{ textAlign: "right", fontSize: 11, color: "var(--color-sumi-muted, #9ca3af)" }}>
            ※外部ETフォームに表示するかどうかを選択できます
          </PoHelper>
        </PoField>
      ) : null}
      {selectOption["option_type"] == 0 ? (
        <SerchTextField
          width="calc(100% - 10px)"
          label={"デフォルト値"}
          helperText={""}
          value={selectOption["option_default_value"]}
          setValue={(value) => {
            if (value === "") {
              setEelectOption({
                ...selectOption,
                option_default_value: value,
                change_value_conf: 0,
              });
            } else {
              setEelectOption({
                ...selectOption,
                option_default_value: value,
              });
            }
          }}
          dataKey={""}
          addData={{}}
          multiline={selectOption.multi_text_flg === 1}
          rows={4}
          testId="product-edit-field-option_default_value"
          fieldKey="option_default_value"
        />
      ) : null}
      {selectOption["option_type"] == 0 ? (
        <PoField testId="product-edit-field-change_value_conf" fieldKey="change_value_conf">
          <PoLabel>入力値の編集</PoLabel>
          <PoSelect
            disabled={selectOption.option_default_value === ""}
            labelId="serch-input-label"
            id="serch-input"
            value={selectOption["change_value_conf"]}
            onChange={(e) => {
              setEelectOption({
                ...selectOption,
                change_value_conf: Number(e.target.value),
              });
            }}
            sx={{ height: 36, fontSize: 13, borderRadius: "var(--radius-sm, 6px)", textAlign: "end" }}
          >
            {LIST_POST["change_value_conf"].map((input, i) => (
              <MenuItem key={"input" + i} value={input.id} sx={{ fontSize: "14px", height: input.value === "" ? "14px" : "24px" }}>
                {input.value}
              </MenuItem>
            ))}
          </PoSelect>
          <PoHelper sx={{ textAlign: "right", fontSize: 11, color: "var(--color-sumi-muted, #9ca3af)" }}>
            ※デフォルト値が設定されているときのみ、入力値の編集を不可に変更できます。
          </PoHelper>
        </PoField>
      ) : null}
      <SerchTextField
        width="calc(100% - 10px)"
        label={"説明"}
        helperText={""}
        value={selectOption["option_comment"]}
        setValue={(value) => {
          setEelectOption({
            ...selectOption,
            option_comment: value,
          });
        }}
        dataKey={""}
        addData={{}}
        testId="product-edit-field-option_comment"
        fieldKey="option_comment"
      />
      <PoField testId="product-edit-field-sns_send" fieldKey="sns_send">
        <PoLabel>チャットアプリ連携</PoLabel>
        <PoSelect
          labelId="serch-input-label"
          id="serch-input"
          value={selectOption["sns_send"]}
          onChange={(e) => {
            setEelectOption({
              ...selectOption,
              sns_send: Number(e.target.value),
            });
          }}
          sx={{ height: 36, fontSize: 13, borderRadius: "var(--radius-sm, 6px)", textAlign: "end" }}
        >
          {LIST_POST["sns_send"].map((input, i) => (
            <MenuItem key={"input" + i} value={input.id} sx={{ fontSize: "14px", height: input.value === "" ? "14px" : "24px" }}>
              {input.value}
            </MenuItem>
          ))}
        </PoSelect>
        <PoHelper sx={{ textAlign: "right", height: "25px", fontSize: 11, color: "var(--color-sumi-muted, #9ca3af)" }}>
          ※チャットアプリ連携した際にエントリー情報として連携するかどうか選択できます。
        </PoHelper>
      </PoField>
      {resolvedFormType === "toss_up_form" &&
      selectOption["tel_flg"] != 1 &&
      selectOption["name_flg"] != 1 &&
      selectOption["company_name_flg"] != 1 ? (
        <Box key={"addBoxOption_depend_plan"}>
          <Box sx={{ fontSize: 12, fontWeight: 600, color: "var(--color-sumi, #374151)", display: "flex", alignItems: "center", gap: "var(--sp-2, 8px)" }}>依存商材選択</Box>
          {editTossUpFormOptionProducts.map((product) => {
            return (
              <Box sx={{ fontSize: 12, fontWeight: 600, color: "var(--color-sumi, #374151)", display: "flex", alignItems: "center", gap: "var(--sp-2, 8px)", marginRight: "25px" }}>
                <Checkbox
                  checked={
                    selectOption.depend_product_ids.findIndex(
                      (planID: number) => planID === product.product_id,
                    ) > -1
                  }
                  onClick={() => {
                    let depend_product_ids =
                      selectOption.depend_product_ids.concat();

                    if (
                      selectOption.depend_product_ids.findIndex(
                        (planID: number) => planID === product.product_id,
                      ) > -1
                    ) {
                      depend_product_ids = depend_product_ids.filter(
                        (planID: number) => planID !== product.product_id,
                      );
                    } else {
                      depend_product_ids.push(product.product_id);
                    }
                    setEelectOption({
                      ...selectOption,
                      depend_product_ids: depend_product_ids,
                    });
                  }}
                  sx={{
                    "& .MuiSvgIcon-root": { fontSize: 16 },
                    marginTop: "-5px",
                  }}
                />
                {`${product.high_rank_company_name} / ${product.product_name}`}
              </Box>
            );
          })}
          <PoHelper sx={{
              textAlign: "right",
              fontSize: 11,
              color: "var(--color-sumi-muted, #9ca3af)",
            }}
          >
            ※依存商材が選択されているかどうかで、質問の表示が制御されます。
          </PoHelper>
        </Box>
      ) : null}
      {resolvedFormType === "entry_form" &&
      selectOption["tel_flg"] != 1 &&
      selectOption["name_flg"] != 1 &&
      selectOption["company_name_flg"] != 1 ? (
        <Box key={"addBoxOption_depend_plan"}>
          <Box sx={{ fontSize: 12, fontWeight: 600, color: "var(--color-sumi, #374151)", display: "flex", alignItems: "center", gap: "var(--sp-2, 8px)" }}>依存プラン選択</Box>
          {editProductOptionPlans.map((service) => {
            return (
              <Box sx={{ fontSize: 12, fontWeight: 600, color: "var(--color-sumi, #374151)", display: "flex", alignItems: "center", gap: "var(--sp-2, 8px)", marginRight: "25px" }}>
                <Checkbox
                  checked={
                    selectOption.depend_plan_ids.findIndex(
                      (planID: number) => planID === service.service_plan_id,
                    ) > -1
                  }
                  onClick={() => {
                    let depend_plan_ids = selectOption.depend_plan_ids.concat();

                    if (
                      selectOption.depend_plan_ids.findIndex(
                        (planID: number) => planID === service.service_plan_id,
                      ) > -1
                    ) {
                      depend_plan_ids = depend_plan_ids.filter(
                        (planID: number) => planID !== service.service_plan_id,
                      );
                    } else {
                      depend_plan_ids.push(service.service_plan_id);
                    }
                    setEelectOption({
                      ...selectOption,
                      depend_plan_ids: depend_plan_ids,
                    });
                  }}
                  sx={{
                    "& .MuiSvgIcon-root": { fontSize: 16 },
                    marginTop: "-5px",
                  }}
                />
                {service.service_plan_name}
              </Box>
            );
          })}
          <PoHelper sx={{
              textAlign: "right",
              fontSize: 11,
              color: "var(--color-sumi-muted, #9ca3af)",
            }}
          >
            ※依存プランが選択されているかどうかで、質問の表示が制御されます。
          </PoHelper>
        </Box>
      ) : null}
      {resolvedFormType === "entry_form" &&
      editProductOptionContents.length > 0 &&
      selectOption["tel_flg"] != 1 &&
      selectOption["name_flg"] != 1 &&
      selectOption["company_name_flg"] != 1 ? (
        <Box key={"addBoxOption_depend_content"}>
          <Box sx={{ fontSize: 12, fontWeight: 600, color: "var(--color-sumi, #374151)", display: "flex", alignItems: "center", gap: "var(--sp-2, 8px)" }}>依存コンテンツ一覧</Box>
          {editProductOptionContents.map((service) => {
            return (
              <Box sx={{ fontSize: 12, fontWeight: 600, color: "var(--color-sumi, #374151)", display: "flex", alignItems: "center", gap: "var(--sp-2, 8px)", marginRight: "25px" }}>
                <Checkbox
                  checked={
                    selectOption.depend_content_ids.findIndex(
                      (contentID: number) =>
                        contentID === service.service_content_id,
                    ) > -1
                  }
                  onClick={() => {
                    let depend_content_ids =
                      selectOption.depend_content_ids.concat();

                    if (
                      selectOption.depend_content_ids.findIndex(
                        (contentID: number) =>
                          contentID === service.service_content_id,
                      ) > -1
                    ) {
                      depend_content_ids = depend_content_ids.filter(
                        (contentID: number) =>
                          contentID !== service.service_content_id,
                      );
                    } else {
                      depend_content_ids.push(service.service_content_id);
                    }
                    setEelectOption({
                      ...selectOption,
                      depend_content_ids: depend_content_ids,
                    });
                  }}
                  sx={{
                    "& .MuiSvgIcon-root": { fontSize: 16 },
                    marginTop: "-5px",
                  }}
                />
                {service.service_content_name}
              </Box>
            );
          })}
          <PoHelper sx={{
              textAlign: "right",
              fontSize: 11,
              color: "var(--color-sumi-muted, #9ca3af)",
            }}
          >
            ※依存コンテンツが選択されているかどうかで、質問の表示が制御されます。
          </PoHelper>
        </Box>
      ) : null}
      {resolvedFormType === "outside_entry_form" &&
      selectOption["tel_flg"] != 1 &&
      selectOption["name_flg"] != 1 &&
      selectOption["company_name_flg"] != 1 &&
      editOutsideServices.length > 0 ? (
        <Box key={"addBoxOption_depend_plan"}>
          <Box sx={{ fontSize: 12, fontWeight: 600, color: "var(--color-sumi, #374151)", display: "flex", alignItems: "center", gap: "var(--sp-2, 8px)" }}>依存外部サービス選択</Box>
          {editOutsideServices.map((service) => {
            return (
              <Box sx={{ fontSize: 12, fontWeight: 600, color: "var(--color-sumi, #374151)", display: "flex", alignItems: "center", gap: "var(--sp-2, 8px)", marginRight: "25px" }}>
                <Checkbox
                  checked={
                    selectOption.depend_outside_entry_form_service_ids.findIndex(
                      (planID: number) =>
                        planID === service.outside_entry_form_service_id,
                    ) > -1
                  }
                  onClick={() => {
                    let depend_outside_entry_form_service_ids =
                      selectOption.depend_outside_entry_form_service_ids.concat();

                    if (
                      selectOption.depend_outside_entry_form_service_ids.findIndex(
                        (planID: number) =>
                          planID === service.outside_entry_form_service_id,
                      ) > -1
                    ) {
                      depend_outside_entry_form_service_ids =
                        depend_outside_entry_form_service_ids.filter(
                          (planID: number) =>
                            planID !== service.outside_entry_form_service_id,
                        );
                    } else {
                      depend_outside_entry_form_service_ids.push(
                        service.outside_entry_form_service_id,
                      );
                    }
                    setEelectOption({
                      ...selectOption,
                      depend_outside_entry_form_service_ids:
                        depend_outside_entry_form_service_ids,
                    });
                  }}
                  sx={{
                    "& .MuiSvgIcon-root": { fontSize: 16 },
                    marginTop: "-5px",
                  }}
                />
                {service.outside_entry_form_service_name}
              </Box>
            );
          })}
          <PoHelper sx={{
              textAlign: "right",
              fontSize: 11,
              color: "var(--color-sumi-muted, #9ca3af)",
            }}
          >
            ※依存外部サービスが選択されているかどうかで、質問の表示が制御されます。
          </PoHelper>
        </Box>
      ) : null}
      {optionNameList.length > 0 &&
      selectOption["tel_flg"] != 1 &&
      selectOption["name_flg"] != 1 &&
      selectOption["company_name_flg"] != 1 ? (
        <Box key={"addBoxOption_depend_option"}>
          <Box sx={{ fontSize: 12, fontWeight: 600, color: "var(--color-sumi, #374151)", display: "flex", alignItems: "center", gap: "var(--sp-2, 8px)" }}>依存質問名選択</Box>
          <FormControl
            fullWidth
            sx={{
              marginTop: "10px",
              marginBottom: "20px",
              marginLeft: "5px",
              width: "calc(100% - 10px)",
            }}
          >
            <Select
              labelId="serch-input-label"
              id="serch-input"
              value={selectOption.depend_option_name}
              onChange={(e) => {
                setEelectOption({
                  ...selectOption,
                  depend_option_name: e.target.value,
                  depend_select_names: [],
                });
              }}
              sx={{ height: 36, fontSize: 13, borderRadius: "var(--radius-sm, 6px)", textAlign: "end" }}
            >
              {optionNameList.map((optionName, i) => {
                if (optionName != selectOption.option_name) {
                  return (
                    <MenuItem
                      key={"input" + i}
                      value={optionName}
                      sx={{
                        fontSize: "14px",
                        height: optionName === "" ? "14px" : "24px",
                      }}
                    >
                      {optionName}
                    </MenuItem>
                  );
                }
              })}
            </Select>
            <PoHelper sx={{
                textAlign: "right",
                fontSize: 11,
                color: "var(--color-sumi-muted, #9ca3af)",
              }}
            >
              ※選択した質問の情報が変更されると、設定が「他質問に依存しない」にリセットされます。
            </PoHelper>
          </FormControl>
        </Box>
      ) : null}

      {selectNameList.length > 0 &&
      selectOption["tel_flg"] != 1 &&
      selectOption["name_flg"] != 1 &&
      selectOption["company_name_flg"] != 1 ? (
        <Box key={"addBoxOption_depend_option_select"}>
          <Box sx={{ fontSize: 12, fontWeight: 600, color: "var(--color-sumi, #374151)", display: "flex", alignItems: "center", gap: "var(--sp-2, 8px)" }}>依存選択肢一覧</Box>
          {selectNameList.map((selectName) => {
            return (
              <Box sx={{ fontSize: 12, fontWeight: 600, color: "var(--color-sumi, #374151)", display: "flex", alignItems: "center", gap: "var(--sp-2, 8px)", marginRight: "25px" }}>
                <Checkbox
                  checked={selectOption.depend_select_names.includes(
                    selectName,
                  )}
                  onClick={() => {
                    let depend_select_names =
                      selectOption.depend_select_names.concat();

                    if (selectOption.depend_select_names.includes(selectName)) {
                      depend_select_names = depend_select_names.filter(
                        (_selectName: string) => _selectName !== selectName,
                      );
                    } else {
                      depend_select_names.push(selectName);
                    }
                    setEelectOption({
                      ...selectOption,
                      depend_select_names: depend_select_names,
                    });
                  }}
                  sx={{
                    "& .MuiSvgIcon-root": { fontSize: 16 },
                    marginTop: "-5px",
                  }}
                />
                {selectName}
              </Box>
            );
          })}
          <PoHelper sx={{
              textAlign: "right",
              fontSize: 11,
              color: "var(--color-sumi-muted, #9ca3af)",
            }}
          >
            ※依存選択肢が選択されているかどうかで、質問の表示が制御されます。
          </PoHelper>
        </Box>
      ) : null}
    </>
  );
}
function SerchTextField({
  width,
  label,
  helperText,
  value,
  setValue,
  dataKey,
  addData,
  multiline,
  rows,
  testId,
  fieldKey,
  required,
}: {
  width: string;
  label: ReactNode;
  helperText: string;
  value: string;
  setValue: (value: string) => void;
  dataKey: string;
  addData: { [key: string]: string | boolean | any[] };
  multiline?: boolean;
  rows?: number;
  testId?: string;
  fieldKey?: string;
  required?: boolean;
}) {
  const inputEl = (
    <PoTextField
      disabled={
        dataKey === "sns_id" &&
        (Number(addData["sns_type"]) == 2 || Number(addData["sns_type"]) == 3)
          ? true
          : false
      }
      type={dataKey !== "password" ? "text" : "password"}
      value={value}
      size="small"
      multiline={multiline}
      rows={rows}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => setValue(e.target.value)}
      sx={{ width: testId ? "100%" : width, ...(testId ? {} : { margin: "10px 5px" }), ...(multiline ? { "& .MuiInputBase-input": { height: "auto" } } : {}) }}
    />
  );
  if (testId) {
    return (
      <PoField fieldKey={fieldKey ?? ""} testId={testId}>
        <PoLabel required={required}>{label}</PoLabel>
        {inputEl}
        {helperText ? <PoHelper>{helperText}</PoHelper> : null}
      </PoField>
    );
  }
  return (
    <Box>
      <Box sx={{ fontSize: 12, fontWeight: 600, color: "var(--color-sumi, #374151)", display: "flex", alignItems: "center", gap: "var(--sp-2, 8px)" }}>{label}</Box>
      {inputEl}
      {helperText ? (
        <PoHelper sx={{ width, textAlign: "right", marginTop: "-8px", height: "25px", fontSize: 11 }}>
          {helperText}
        </PoHelper>
      ) : null}
    </Box>
  );
}

interface ProductEditModalProps {
  onModal: boolean;
  swCloseModal: () => void;
  editProduct: { [key: string]: any } | null;
  setEditProduct: (data: { [key: string]: any } | null) => void;
  putEditProduct: () => void;
  editProductOptionPlans: {
    service_plan_id: number;
    service_plan_name: string;
  }[];
  editProductOptionContents: {
    service_content_id: number;
    service_content_name: string;
  }[];
  editTossUpFormOptionProducts: {
    high_rank_company_name: string;
    product_id: number;
    product_name: string;
  }[];
  editOutsideServices: {
    outside_entry_form_service_id: number;
    outside_entry_form_service_name: string;
  }[];
  formTitle?: string;
  formType?: "entry_form" | "toss_up_form" | "outside_entry_form";
}
export function ProductEditModal(props: ProductEditModalProps) {
  const {
    onModal,
    swCloseModal,
    editProduct,
    setEditProduct,
    putEditProduct,
    editProductOptionPlans,
    editProductOptionContents,
    editTossUpFormOptionProducts,
    editOutsideServices,
    formTitle,
    formType,
  } = props;
  const pathname = useAtomValue(AppAtoms.pathname);
  const resolvedFormType = formType ?? (pathname === "/entry_form" ? "entry_form" : pathname === "/toss_up_form" ? "toss_up_form" : pathname === "/outside_entry_form" ? "outside_entry_form" : null);
  const isSmartPhone = useAtomValue(AppAtoms.isSmartPhone);

  // 依存質問 - 選択肢の一覧
  const [optionNameList, setOptionNameList] = useState<string[]>([]);
  useEffect(() => {
    let optionNameList: string[] = ["他質問に依存しない"];
    if (editProduct && editProduct.product_option) {
      editProduct.product_option.map((optionInf: any) => {
        if (optionInf.option_type === 1 || optionInf.option_type === 2) {
          optionNameList.push(optionInf.option_name);
        }
      });
    }
    setOptionNameList(optionNameList);
  }, [editProduct]);

  // ★cmd-po_1221 R9: 成功トースト+自動クローズ処理を廃止＝結果モーダル統一。

  // ドラッグが完了した際に呼ばれるコールバック
  const onDragEnd = (result: DropResult) => {
    const { source, destination } = result;
    // ドロップ先がない(リスト外にドロップされた)場合は何もしない
    if (!destination || !editProduct) return;

    // 元の場所と同じ場合は並び替え不要
    if (
      source.droppableId === destination.droppableId &&
      source.index === destination.index
    ) {
      return;
    }

    // 配列をコピーし、ドラッグされた要素を抜き出し、目的地へ挿入
    const newProductOptions = Array.from(editProduct.product_option);
    const [removed] = newProductOptions.splice(source.index, 1);
    newProductOptions.splice(destination.index, 0, removed);

    // 並び替えが完了した後、sort_id を並び順に合わせて更新する
    // (1スタートの場合は index+1、0スタートなら index を使ってください)
    newProductOptions.forEach((option: any, index: number) => {
      option.sort_id = index + 1;
    });
    // 更新した配列をStateに反映させる
    setEditProduct({
      ...editProduct,
      product_option: newProductOptions,
    });
  };

  return editProduct ? (
    <>
    <PoModalShell
      open={onModal && editProduct?.status !== "success"}
      title={formTitle ?? (resolvedFormType === "entry_form"
        ? "エントリーフォーム - 質問一覧編集"
        : resolvedFormType === "toss_up_form"
          ? "トスアップフォーム - 質問一覧編集"
          : resolvedFormType === "outside_entry_form"
            ? "外部ETフォーム - 質問一覧編集"
            : "フォーム管理 - 質問一覧編集")}
      onClose={swCloseModal}
      testidPrefix="product-edit"
      frameTestId="product-edit-modal"
      widthPx={
        editProduct.status === "before"
          ? editProduct.select_option_index == null ? 560 : 640
          : 500
      }
      footer={
        editProduct.status === "before" ? (
          editProduct.select_option_index == null ? (
            <>
              <PoButton variant="secondary" onClick={swCloseModal}>戻る</PoButton>
              <PoButton
                variant="primary"
                disabled={editProduct.product_option.length === 0}
                onClick={() => {
                  const invalidOption = (editProduct.product_option as any[]).find(
                    (opt: any) => typeof opt.option_default_value === "string" && opt.option_default_value.includes("\n") && opt.multi_text_flg !== 1
                  );
                  if (invalidOption) {
                    setEditProduct({
                      ...editProduct,
                      status: `質問名「${invalidOption.option_name}」：「デフォルト値」に改行が含まれています。改行は「複数行フラグ」設定時のみ使用できます。`,
                    });
                    return;
                  }
                  putEditProduct();
                }}
              >確定</PoButton>
            </>
          ) : (
            <>
              <PoButton
                variant="secondary"
                onClick={() => {
                  let product_option = editProduct.product_option.concat();
                  if (editProduct.add_select_option_flg) {
                    product_option = product_option.filter(
                      (_product_option: any, _option_i: number) =>
                        editProduct.select_option_index !== _option_i,
                    );
                  }
                  setEditProduct({
                    ...editProduct,
                    select_option_index: null,
                    select_option: null,
                    add_select_option_flg: false,
                    product_option,
                  });
                }}
              >戻る</PoButton>
              <PoButton
                variant="primary"
                disabled={editProduct.select_option.option_name === ""}
                onClick={() => {
                  let product_option = editProduct.product_option.concat();
                  const edit_option_name = product_option[editProduct.select_option_index].option_name;
                  product_option[editProduct.select_option_index] = editProduct.select_option;
                  product_option = product_option.map((product_option: any) => {
                    if (edit_option_name === product_option.depend_option_name) {
                      product_option["depend_option_name"] = "他質問に依存しない";
                      product_option["depend_select_names"] = [];
                    }
                    return product_option;
                  });
                  setEditProduct({
                    ...editProduct,
                    select_option_index: null,
                    select_option: null,
                    add_select_option_flg: false,
                    product_option,
                  });
                }}
              >編集</PoButton>
            </>
          )
        ) : editProduct.status !== "success" && editProduct.status !== "before" ? (
          <PoButton
            variant="primary"
            onClick={() => {
              if (editProduct.status && editProduct.status.startsWith("編集に成功しました。")) {
                swCloseModal();
              } else {
                setEditProduct({ ...editProduct, status: "before" });
              }
            }}
          >OK</PoButton>
        ) : null
      }
    >
          {editProduct.status === "before" ? (
            <>
              <Paper elevation={0}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "var(--sp-4, 16px)",
                  }}
                >
                  {editProduct.select_option_index == null ? (
                    <>
                      {resolvedFormType === "entry_form" ||
                      resolvedFormType === "outside_entry_form" ? (
                        <>
                          <Box key={"addBoxProductName"}>
                            <Box sx={{ fontSize: 12, fontWeight: 600, color: "var(--color-sumi, #374151)", display: "flex", alignItems: "center", gap: "var(--sp-2, 8px)" }}>商材名</Box>
                            <PoTextField
                              disabled
                              size="small"
                              value={editProduct.product_name}
                              sx={{
                                width: "calc(100% - 10px)",
                                margin: "10px 5px ",
                              }}
                            />
                          </Box>
                          <Box key={"addBoxEntrySaleCompanyName"}>
                            <Box sx={{ fontSize: 12, fontWeight: 600, color: "var(--color-sumi, #374151)", display: "flex", alignItems: "center", gap: "var(--sp-2, 8px)" }}>
                              エントリーパートナー
                            </Box>
                            <PoTextField
                              disabled
                              size="small"
                              value={editProduct.entry_sale_company_name}
                              sx={{
                                width: "calc(100% - 10px)",
                                margin: "10px 5px ",
                              }}
                            />
                          </Box>
                        </>
                      ) : resolvedFormType === "toss_up_form" ? (
                        <>
                          <Box key={"addBoxCategoryName"}>
                            <Box sx={{ fontSize: 12, fontWeight: 600, color: "var(--color-sumi, #374151)", display: "flex", alignItems: "center", gap: "var(--sp-2, 8px)" }}>カテゴリ名</Box>
                            <PoTextField
                              disabled
                              size="small"
                              value={editProduct.category_name}
                              sx={{
                                width: "calc(100% - 10px)",
                                margin: "10px 5px ",
                              }}
                            />
                          </Box>
                          <Box key={"addBoxEntrySaleCompanyName"}>
                            <Box sx={{ fontSize: 12, fontWeight: 600, color: "var(--color-sumi, #374151)", display: "flex", alignItems: "center", gap: "var(--sp-2, 8px)" }}>
                              トスアップパートナー
                            </Box>
                            <PoTextField
                              disabled
                              size="small"
                              value={editProduct.toss_up_company_name}
                              sx={{
                                width: "calc(100% - 10px)",
                                margin: "10px 5px ",
                              }}
                            />
                          </Box>
                        </>
                      ) : null}
                      <DragDropContext onDragEnd={onDragEnd}>
                        <Droppable droppableId="droppable">
                          {(provided) => (
                            <Box
                              data-testid="product-question-list"
                              ref={provided.innerRef}
                              {...provided.droppableProps}
                              sx={{ width: "100%", display: "flex", flexDirection: "column" }}
                            >
                              <Box
                                sx={{ fontSize: 12, fontWeight: 600, color: "var(--color-sumi, #374151)", display: "flex", alignItems: "center", gap: "var(--sp-2, 8px)", marginTop: "15px", marginBottom: "10px" }}
                              >
                                質問一覧
                              </Box>
                              <Box data-testid="product-edit-note" sx={{ fontSize: 12, color: "var(--color-sumi-light)" }}>質問を選択すると編集画面へ移動します</Box>
                              {editProduct.product_option.map(
                                (option: any, index: number) => (
                                  <Draggable
                                    key={option.sort_id}
                                    draggableId={String(option.sort_id)}
                                    index={index}
                                  >
                                    {(
                                      provided: DraggableProvided,
                                      snapshot: DraggableStateSnapshot,
                                    ) => (
                                      <>
                                        <Box
                                          key={"option_name_" + index}
                                          data-testid="product-question-row"
                                          data-selected={editProduct.select_option_index === index ? "true" : undefined}
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "var(--sp-2, 8px)",
                                            padding: "var(--sp-2, 8px) var(--sp-3, 12px)",
                                            borderBottomWidth: "1px",
                                            borderBottomStyle: "solid",
                                            borderBottomColor: "var(--color-border-light, #efefea)",
                                            fontSize: "var(--fs-13, 13px)",
                                            color: "var(--color-sumi, #374151)",
                                            ...(editProduct.select_option_index === index ? {
                                              bgcolor: "var(--color-ai-pale)",
                                              color: "var(--color-ai)",
                                              fontWeight: "var(--fw-bold, 700)",
                                              borderLeft: "3px solid var(--color-ai)",
                                            } : {}),
                                            ...(snapshot.isDragging ? { bgcolor: "var(--color-ai-pale)" } : {}),
                                          }}
                                          onClick={() => {
                                            setEditProduct({
                                              ...editProduct,
                                              select_option_index: index,
                                              select_option: option,
                                            });
                                          }}
                                        >
                                          {option.option_name}
                                          <Box
                                            component="span"
                                            data-testid="product-question-type"
                                            sx={{ marginLeft: "auto", fontSize: "var(--fs-11, 11px)", color: "var(--color-sumi-muted, #9ca3af)" }}
                                          >
                                            {LIST_POST["option_type"].find((t: any) => t.id === option.option_type)?.value}
                                          </Box>
                                          <ChevronRightIcon
                                            data-testid="product-question-chev"
                                            fontSize="small"
                                            sx={{ color: "var(--color-sumi-muted, #9ca3af)", display: "inline-flex" }}
                                          />
                                          {editProduct.product_option.length >
                                          1 ? (
                                            <Button
                                              sx={{
                                                height: "32px",
                                                width: "32px",
                                              }}
                                              onClick={(e) => {
                                                e.stopPropagation();
                                              let product_option =
                                                editProduct.product_option.concat();
                                              const edit_option_name =
                                                option.option_name;

                                              //質問の削除
                                              product_option =
                                                product_option.filter(
                                                  (
                                                    _product_option: any,
                                                    _option_i: number,
                                                  ) => index !== _option_i,
                                                );

                                              // 依存設定の削除
                                              product_option =
                                                product_option.map(
                                                  (product_option: any) => {
                                                    if (
                                                      edit_option_name ===
                                                      product_option.depend_option_name
                                                    ) {
                                                      product_option[
                                                        "depend_option_name"
                                                      ] = "他質問に依存しない";
                                                      product_option[
                                                        "depend_select_names"
                                                      ] = [];
                                                    }
                                                    return product_option;
                                                  },
                                                );

                                              const option_id =
                                                option.option_id;
                                              let delete_option =
                                                editProduct.delete_option.concat();
                                              if (option_id) {
                                                delete_option.push(option_id);
                                              }
                                              setEditProduct({
                                                ...editProduct,
                                                product_option,
                                                delete_option,
                                              });
                                              }}
                                            >
                                              <RemoveCircleOutlineIcon fontSize="medium" />
                                            </Button>
                                          ) : null}
                                        </Box>
                                      </>
                                    )}
                                  </Draggable>
                                ),
                              )}
                              {provided.placeholder}
                            </Box>
                          )}
                        </Droppable>
                      </DragDropContext>
                      <Box
                        data-testid="product-edit-add-row"
                        sx={{
                          padding: "var(--sp-2, 8px) 0",
                          width: "100%",
                        }}
                      >
                        <Button
                          data-testid="product-edit-add-button"
                          variant="outlined"
                          sx={{
                            width: "100%",
                            justifyContent: "center",
                          }}
                          onClick={() => {
                            let product_option =
                              editProduct.product_option.concat();
                            let max_sort_id = 1;
                            product_option.map((option: any) => {
                              if (option.sort_id > max_sort_id) {
                                max_sort_id = option.sort_id;
                              }
                            });
                            product_option.push({
                              option_name: "",
                              sns_send: 1,
                              required_optional: 0,
                              option_type: 0,
                              option_default_value: "",
                              change_value_conf: 0,
                              option_comment: "",
                              tel_flg: 0,
                              name_flg: 0,
                              company_name_flg: 0,
                              zip_code_flg: 0,
                              address_flg: 0,
                              space_flg: 0,
                              mail_address_flg: 0,
                              form_tel_flg: 0,
                              multi_text_flg: 0,
                              half_width_number_flg: 0,
                              contract_number_flg: 0,
                              option_select: [""],
                              sort_id: max_sort_id + 1,
                              outside_form_display: 0,
                              depend_product_ids: [],
                              depend_plan_ids: [],
                              depend_content_ids: [],
                              depend_outside_entry_form_service_ids: [],
                              depend_option_name: "他質問に依存しない",
                              depend_select_names: [],
                            });
                            setEditProduct({
                              ...editProduct,
                              product_option,
                              select_option_index:
                                editProduct.product_option.length,
                              select_option: {
                                option_name: "",
                                sns_send: 1,
                                required_optional: 0,
                                option_type: 0,
                                option_default_value: "",
                                change_value_conf: 0,
                                option_comment: "",
                                tel_flg: 0,
                                name_flg: 0,
                                company_name_flg: 0,
                                zip_code_flg: 0,
                                address_flg: 0,
                                space_flg: 0,
                                mail_address_flg: 0,
                                form_tel_flg: 0,
                                multi_text_flg: 0,
                                half_width_number_flg: 0,
                                contract_number_flg: 0,
                                option_select: [""],
                                sort_id: max_sort_id + 1,
                                outside_form_display: 0,
                                depend_product_ids: [],
                                depend_plan_ids: [],
                                depend_content_ids: [],
                                depend_outside_entry_form_service_ids: [],
                                depend_option_name: "他質問に依存しない",
                                depend_select_names: [],
                              },
                              add_select_option_flg: true,
                            });
                          }}
                        >
                          <Box>
                            質問追加
                          </Box>
                          <AddCircleOutlineIcon
                            sx={{
                              marginLeft: "6px",
                            }}
                            fontSize="medium"
                          />
                        </Button>
                      </Box>
                    </>
                  ) : (
                    editProduct.product_option.map(
                      (option: any, option_i: number) => {
                        if (editProduct.select_option_index === option_i) {
                          return (
                            <InputProductOption
                              selectOption={editProduct.select_option}
                              setEelectOption={(select_option: any) => {
                                setEditProduct({
                                  ...editProduct,
                                  select_option: select_option,
                                });
                              }}
                              editProductOptionPlans={editProductOptionPlans}
                              editProductOptionContents={
                                editProductOptionContents
                              }
                              editTossUpFormOptionProducts={
                                editTossUpFormOptionProducts
                              }
                              editOutsideServices={editOutsideServices}
                              optionNameList={optionNameList}
                              editProduct={editProduct}
                              formType={formType}
                            />
                          );
                        }
                      },
                    )
                  )}
                </Box>
              </Paper>
            </>
          ) : editProduct.status === "failed" ? (
            <Box>
              データの登録に失敗しました。
              <br />
              データの形式が異なる可能性があります。
            </Box>
          ) : editProduct.status === "success" ? null : (
            <Box>
              {editProduct.status}
            </Box>
          )}
    </PoModalShell>
    {/* ★cmd-po_1221 R9: 編集成功=結果モーダル（トースト→統一・閉じるで手動クローズ） */}
    <DataAddModalResult
      onModal={onModal && editProduct?.status === "success"}
      onDataAddModalResult="success"
      successMessage="変更を保存しました。"
      swCloseModal={swCloseModal}
      addModalTitle="編集"
    />
    </>
  ) : null;
}
